export const THEMES = Object.freeze({
  LIGHT: "light",
  DARK: "dark",
  EVERGREEN: "evergreen",
});

export const DEFAULT_THEME = THEMES.LIGHT;
export const THEME_STORAGE_KEY = "mobasher-panel-theme";
export const THEME_VALUES = Object.freeze(Object.values(THEMES));
export const THEME_META_COLORS = Object.freeze({
  [THEMES.LIGHT]: "#f3f4f6",
  [THEMES.DARK]: "#0c110f",
  [THEMES.EVERGREEN]: "#051c15",
});

export const isTheme = (value) => THEME_VALUES.includes(value);
